<template>
    <v-tabs centered color="white" class="custom_tabs">
        <v-icon class="custom_return_icon" @click="augmentationsRedirection">
            fas fa-angle-left
        </v-icon>
        <v-tabs-slider class="custom_tabs_slider" />
        <v-tab v-for="(tab, index) in tabs" :key="index" :href="'#tab-' + (index + 1)">
            <v-icon :class="[isMobile ? 'active' : '']" class="custom_tab_icon">
                fas fa-{{ tab.icon }}
            </v-icon>
            <div v-if="!isMobile" class="custom_tab_text">
                {{ tab.title }}
            </div>
        </v-tab>
        <v-tab-item v-for="(tab, index) in tabs" :key="index" :value="'tab-' + (index + 1)" class="custom_tab_item">
            <actions-tab-content v-if="tab.component === 'actionsContent'" />
            <actions-tab-parameters v-if="tab.component === 'actionsParameters'" />
        </v-tab-item>
    </v-tabs>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'ActionsContent',
        components: {
            ActionsTabParameters: () => import('./ActionsTabParameters'),
            ActionsTabContent: () => import('./ActionsTabContent')
        },
        data: () => ({
            tabs: [
                { icon: 'images', title: 'Mes Contenus', component: 'actionsContent' },
                { icon: 'sliders-h', title: 'Paramètres', component: 'actionsParameters' }
            ]
        }),
        computed: {
            ...mapGetters('actions', ['experience']),
            ...mapGetters('app', ['isMobile'])
        },
        methods: {
            ...mapActions('actions', ['tryRedirection']),
            augmentationsRedirection: function () {
                this.tryRedirection().then((success) => {
                    if (success) {
                        this.$router.push({
                            name: 'augmentations',
                            params: { experienceToken: this.$route.params.experienceToken }
                        });
                    }
                }).catch((err) => {
                    this.$toasted.error(err);
                });
            }
        }
    };
</script>

<style lang="scss" scoped>

    .custom_tabs_slider {
        background-color: #169CEB;
    }

    .custom_tab_icon {
        margin-right: 10px;
        font-size: 20px;
    }

    .custom_tab_icon.active {
        margin-left: 10px;
    }

    .custom_tab_text {
        text-transform: capitalize;
    }

    .custom_return_icon {
        margin-left: 0 !important;
        width: 70px;
    }

    .custom_tab_item {
        background-color: #F1F1F1;
        min-height: calc(100vh - 223px) !important;
    }

    .container.grid-list-md {
        min-width: 100% !important;
    }

    .v-tab.v-tab {
        color: rgba(0, 0, 0, 0.54);
    }
</style>
